import { FormTitleFontStyle, isFormTitleFontStyle } from "@simplyk/common";

interface FontStyleConfig {
  fontFamily: string;
  fontWeight: number;
  desktopFontSize: string;
  desktopLineHeight: string;
  mobileFontSize: string;
  mobileLineHeight: string;
}

const FONT_STYLE_CONFIGS: Record<FormTitleFontStyle, FontStyleConfig> = {
  [FormTitleFontStyle.Classic]: {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 600,
    desktopFontSize: "34px",
    desktopLineHeight: "44px",
    mobileFontSize: "26px",
    mobileLineHeight: "34px",
  },
  [FormTitleFontStyle.Elegant]: {
    fontFamily: "'Playfair Display', serif",
    fontWeight: 900,
    desktopFontSize: "37px",
    desktopLineHeight: "50px",
    mobileFontSize: "28px",
    mobileLineHeight: "40px",
  },
  [FormTitleFontStyle.Handwritten]: {
    fontFamily: "'Pacifico', cursive",
    fontWeight: 400,
    desktopFontSize: "34px",
    desktopLineHeight: "42px",
    mobileFontSize: "25px",
    mobileLineHeight: "34px",
  },
  [FormTitleFontStyle.SlabSerif]: {
    fontFamily: "'Alfa Slab One', serif",
    fontWeight: 400,
    desktopFontSize: "33px",
    desktopLineHeight: "36px",
    mobileFontSize: "25px",
    mobileLineHeight: "30px",
  },
  [FormTitleFontStyle.Futuristic]: {
    fontFamily: "'Orbitron', sans-serif",
    fontWeight: 700,
    desktopFontSize: "31px",
    desktopLineHeight: "40px",
    mobileFontSize: "23px",
    mobileLineHeight: "32px",
  },
  [FormTitleFontStyle.Bubbly]: {
    fontFamily: "'Fredoka One', sans-serif",
    fontWeight: 400,
    desktopFontSize: "36px",
    desktopLineHeight: "40px",
    mobileFontSize: "27px",
    mobileLineHeight: "32px",
  },
};

export function getFontStyleConfig(fontStyle: FormTitleFontStyle | string | null | undefined): FontStyleConfig {
  if (!fontStyle || !isFormTitleFontStyle(fontStyle)) {
    return FONT_STYLE_CONFIGS[FormTitleFontStyle.Classic];
  }
  return FONT_STYLE_CONFIGS[fontStyle];
}
